<template>
  <div>
    <v-row>
      <v-col
        sm="12"
        md="9"
      >
        <h3 class="ma-4">チャレンジ</h3>
        <ChallengeList :query="query" />
      </v-col>

      <v-col
        sm="12"
        md="3"
      >
        <v-alert
          color="grey darken-3"
          outlined
        >
          <div class="text-h6">
            ようこそ
          </div>
          <div>
            HLS チャレンジで高位合成によるハードウェア設計を習得しましょう。このサイトについては<router-link to="/about">こちら</router-link>。
          </div>
        </v-alert>

        <v-alert
          color="primary"
          outlined
        >
          <div class="text-h6">
            ニュース
          </div>
          <div>
            <ul>
              <li>2021/9/24 <a href="https://gw.acri.c.titech.ac.jp/wp/forums/forum/hls-challenge">フォーラム</a>を設置しました。</li>
              <li>2021/8/31 サイクル数の算出方法を変更しました。</li>
              <li>2021/8/24 サイトを公開しました。</li>
            </ul>
          </div>
        </v-alert>

        <RecentResultList :query="recentResultQuery" />

      </v-col>
    </v-row>
  </div>
</template>

<script>
//import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
import ChallengeList from '@/components/ChallengeList.vue'
import RecentResultList from '@/components/RecentResultList.vue'

export default {
  name: 'Home',
  components: {
    ChallengeList,
    RecentResultList,
  },
  data: () => ({
    query: null,
    recentResultQuery: null,
  }),
  created() {
    this.query = db.collectionGroup('challenges').where('publish', '==', true)
    this.recentResultQuery = db.collectionGroup("codes")
  }
}
</script>
